var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Sentry from "@sentry/browser";
import $ from 'jquery';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import { Carousel } from "@fancyapps/ui/dist/carousel/";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";
import "@fancyapps/ui/dist/carousel/carousel.dots.css";
import "@fancyapps/ui/dist/carousel/carousel.css";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/carousel/carousel.arrows.css";
import 'material-icons/iconfont/filled.css';
import { compact } from "./analytics";
export { runSearchResults } from './search';
/**
 * Applies a cart mutation's JSON response to the header badge and the
 * wide-screen floating sidebar -- shared by the sitewide delegated
 * "Add to cart" handler (see init()) and the item page's mobile quantity
 * stepper (see runItem()), so both stay in sync with the same session
 * cart regardless of which one a shopper just used.
 */
function applyCartUpdate(data) {
    var badge = document.getElementById('cart-badge');
    if (badge) {
        badge.textContent = String(data.cart_item_count);
        badge.hidden = data.cart_item_count === 0;
    }
    var sidebar = document.getElementById('cart-sidebar');
    if (sidebar && data.cart_sidebar_html) {
        sidebar.outerHTML = data.cart_sidebar_html;
    }
    // Switches every "add to cart" control for this ref (see
    // _item-card.html's .quick-add-to-cart pin and .zoom-add-to-cart lightbox
    // button) from its default light "not yet in cart" background to the red
    // "already in cart" one -- keyed by data-ref rather than the specific
    // button clicked, so adding from either one updates both.
    if (data.ref) {
        var ref = CSS.escape(data.ref);
        document.querySelectorAll(".quick-add-to-cart[data-ref=\"".concat(ref, "\"], .zoom-add-to-cart[data-ref=\"").concat(ref, "\"]")).forEach(function (button) {
            button.classList.add('in-cart');
        });
        // The live update above only reaches a .zoom-add-to-cart that's
        // already in the DOM, i.e. a lightbox that's open right now --
        // Fancybox instead renders each future open fresh from the trigger's
        // own data-caption HTML string (see init()'s click handler comment),
        // so that stored string needs the same class added, or the next open
        // would revert to showing the light "not yet in cart" look.
        document.querySelectorAll("a.zoom[data-ref=\"".concat(ref, "\"]")).forEach(function (trigger) {
            var caption = trigger.getAttribute('data-caption');
            if (caption) {
                trigger.setAttribute('data-caption', caption.replace('class="zoom-add-to-cart"', 'class="zoom-add-to-cart in-cart"'));
            }
        });
    }
}
/**
 * "Flies" a clone of sourceImg from its current on-screen position to the
 * header's basket icon, shrinking and fading out along the way, then
 * pulses the badge once it lands -- used after adding to cart from
 * within a Fancybox zoom (see init()'s delegated data-add-to-cart
 * handler), right after Fancybox.close()'s own built-in zoom-back-out
 * transition, so a shopper visibly sees the item return to the page and
 * head to the basket instead of just vanishing.
 */
function flyToCart(sourceImg) {
    var cartIcon = document.querySelector('.cart-link .material-icons');
    if (!cartIcon) {
        return;
    }
    var startRect = sourceImg.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) {
        return; // Source not actually visible (e.g. off-screen) -- skip.
    }
    var flyer = sourceImg.cloneNode(false);
    flyer.style.position = 'fixed';
    flyer.style.left = "".concat(startRect.left, "px");
    flyer.style.top = "".concat(startRect.top, "px");
    flyer.style.width = "".concat(startRect.width, "px");
    flyer.style.height = "".concat(startRect.height, "px");
    flyer.style.margin = '0';
    flyer.style.zIndex = '9999';
    flyer.style.pointerEvents = 'none';
    flyer.style.borderRadius = '50%';
    flyer.style.objectFit = 'cover';
    flyer.style.transition = 'transform 0.6s ease-in, opacity 0.6s ease-in';
    document.body.appendChild(flyer);
    var deltaX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    var deltaY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);
    var scale = Math.min(endRect.width / startRect.width, endRect.height / startRect.height);
    // Forces the browser to actually commit/paint the flyer at its
    // starting position before the transform/opacity change below --
    // without reading a layout property first, appending the element and
    // changing its transitioned properties in the very next frame can
    // collapse into a single paint on some browsers, skipping the
    // animation instead of playing it (a classic CSS-transition-on-a-
    // freshly-inserted-element gotcha -- requestAnimationFrame alone
    // isn't a reliable enough guarantee here).
    void flyer.offsetWidth;
    flyer.style.transform = "translate(".concat(deltaX, "px, ").concat(deltaY, "px) scale(").concat(scale, ")");
    flyer.style.opacity = '0.2';
    setTimeout(function () {
        flyer.remove();
        var badge = document.getElementById('cart-badge');
        if (badge) {
            badge.classList.add('cart-badge-pulse');
            setTimeout(function () { return badge.classList.remove('cart-badge-pulse'); }, 400);
        }
    }, 620);
}
/**
 * Tracks events in Umami.
 *
 * @param eventName Name of the event (e.g. "View Item").
 * @param eventData Optional key-value dictionary of properties (e.g. {variant: 'foo'}).
 */
export function umamiTrack(eventName, eventData) {
    if (!window.umami) {
        var error = new Error('Umami not initialized.');
        if (Sentry) {
            Sentry.captureException(error);
        }
        else {
            console.error(error);
        }
        return;
    }
    window.umami.track(eventName, eventData);
}
/**
 * Tracks events in Gtag and Umami.
 *
 * @param eventName Name of the event (e.g. "View Item").
 * @param eventData Optional key-value dictionary of properties (e.g. {variant: 'foo'}).
 */
export function track(eventName, eventData) {
    umamiTrack(eventName, eventData);
    gtag('event', eventName, eventData);
}
var zoomCategory;
var zoomSubCategory;
/**
 * Sets the category/sub-category attributed to a subsequent Fancybox zoom's
 * "View Item" tracking, without runCategory()'s other category-page-only
 * side effects (view_item_list/"View Category" events) -- used by
 * search.ts, whose items reuse the same _item-card.html zoom lightbox but
 * aren't a category listing.
 */
export function setZoomTrackingContext(category, subCategory) {
    zoomCategory = category;
    zoomSubCategory = subCategory;
}
var searchFilterContextGetter = null;
/**
 * search.ts registers a getter returning the current active-filter
 * snapshot; the zoom and add-to-cart handlers below attach it to a
 * "Search Result Engagement" event when the interaction happened inside
 * the search/category results grid. Never cleared -- the page never stops
 * being a results page once it is one.
 * See docs/superpowers/specs/2026-08-29-search-filter-analytics-design.md.
 */
export function setSearchFilterContext(getter) {
    searchFilterContextGetter = getter;
}
/**
 * Records interest in a specific result under the filter state that
 * surfaced it. `trigger` is the clicked/zoomed element; its enclosing
 * .item-preview gives the ref (from the card's a.zoom[data-ref]) and the
 * 0-based position in #search-result-grid.
 */
export function emitSearchResultEngagement(type, trigger) {
    var _a, _b, _c;
    if (!searchFilterContextGetter) {
        return;
    }
    var card = trigger === null || trigger === void 0 ? void 0 : trigger.closest('.item-preview');
    var grid = document.getElementById('search-result-grid');
    var ref = (_b = (_a = card === null || card === void 0 ? void 0 : card.querySelector('a.zoom[data-ref]')) === null || _a === void 0 ? void 0 : _a.dataset.ref) !== null && _b !== void 0 ? _b : (trigger === null || trigger === void 0 ? void 0 : trigger.dataset.ref);
    var position;
    if (card && grid) {
        var index = Array.prototype.indexOf.call(grid.children, card);
        position = index >= 0 ? index : undefined;
    }
    var snapshot = searchFilterContextGetter();
    umamiTrack('Search Result Engagement', compact(__assign({ type: type, ref: ref, position: position }, snapshot)));
    if (type === 'click' && ref) {
        var listId = snapshot.context === 'search' ? 'search' : String((_c = snapshot.page_group) !== null && _c !== void 0 ? _c : 'search');
        gtag('event', 'select_item', {
            item_list_id: listId,
            item_list_name: 'Search results',
            items: [{ item_id: ref }],
        });
    }
}
function requiredQuerySelector(selector) {
    var elm = document.querySelector(selector);
    if (!elm) {
        throw new Error("Failed to locate required element: \"".concat(selector, "\"."));
    }
    return elm;
}
function convertProductToGA4Item(product) {
    var _a;
    return {
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: (_a = product.quantity) !== null && _a !== void 0 ? _a : 1,
    };
}
function convertProductsToGA4Items(products) {
    var items = [];
    for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
        var product = products_1[_i];
        items.push(convertProductToGA4Item(product));
    }
    return items;
}
function getProductsTotal(products) {
    var _a;
    var total = 0;
    for (var _i = 0, products_2 = products; _i < products_2.length; _i++) {
        var product = products_2[_i];
        total += product.price * ((_a = product.quantity) !== null && _a !== void 0 ? _a : 1);
    }
    return total;
}
/**
 * Whether `country` is a destination the store ships to — i.e. the ship-to
 * <select> offers an <option> for it. GeoIP (ipinfo.io) can report a
 * country we don't ship to (most of Africa, Russia, much of the Middle
 * East) or, on a bogon/rate-limited response, none at all; POSTing either
 * to /cart/shipping-country only earns a 400 (see UpdateShippingCountryApi).
 */
function isOfferedShippingCountry(dropdown, country) {
    return typeof country === 'string'
        && dropdown.find('option').toArray().some(function (option) { return option.value === country; });
}
/**
 * base.html
 * Initializes Sentry error tracking.
 *
 * Should be one of the first script to run.
 *
 * @param dsn Sentry DSN URL.
 * @param environment Deployement environement (e.g. "production").
 * @param release Release version (e.g. "1.0.0").
 * @param debug Whether this is the debug version or the production version.
 */
export function init(dsn, environment, release, debug) {
    var _this = this;
    var _a;
    try {
        // https://docs.sentry.io/platforms/javascript/
        // https://github.com/getsentry/sentry-javascript/tree/master/packages/browser
        Sentry.init({
            dsn: dsn,
            environment: environment,
            release: release,
            debug: debug,
            integrations: [
                // Avoids splitting /js/bundle.js?v=123 by version.
                Sentry.rewriteFramesIntegration({
                    // This function runs on every stack frame before sending the error
                    iteratee: function (frame) {
                        if (frame.filename) {
                            // Split on '?' (query) or '#' (hash) and take the first part only
                            // Input:  "https://example.com/js/bundle.js?v=123"
                            // Output: "https://example.com/js/bundle.js"
                            frame.filename = frame.filename.split(/[?#]/)[0];
                        }
                        return frame;
                    },
                }),
                // Captures failed HTTP requests (fetch/XHR) as errors.
                Sentry.httpClientIntegration({
                    // Define which status codes should mark the transaction span as "failed".
                    // By default, Sentry might only consider 5xx failures.
                    failedRequestStatusCodes: [[400, 599]],
                    // Only instrument requests matching these regex patterns.
                    failedRequestTargets: [
                        /^https:\/\/[^\/]*pierre-bex\.[a-z]+\//,
                        /^https:\/\/[^\/]*libertys\.[a-z]+\//,
                        /^https:\/\/[^\/]*alc\.net\//,
                    ],
                }),
            ],
        });
    }
    catch (error) {
        // We can't do much but let's continue the script.
        console.error(error);
    }
    if (window.umami) {
        var params = new URLSearchParams(window.location.search);
        var referrer_1 = document.referrer;
        var utmSource = params.get('utm_source');
        if (params.has('srsltid')) {
            referrer_1 = 'https://Merchants.Google.com';
        }
        else if (utmSource) {
            switch (utmSource) {
                case 'chatgpt':
                case 'chatgpt.com':
                    referrer_1 = 'https://ChatGPT.com';
                    break;
                case 'facebook':
                case 'facebook.com':
                    referrer_1 = 'https://Facebook.com';
                    break;
                case 'instagram':
                case 'instagram.com':
                    referrer_1 = 'https://Instagram.com';
                    break;
                case 'twitter':
                case 'twitter.com':
                case 't.co':
                    referrer_1 = 'https://Twitter.com';
                    break;
                // default to using the utm_source if it's not in our list
                default:
                    referrer_1 = utmSource;
                    break;
            }
        }
        window.umami.track(function (props) { return (__assign(__assign({}, props), { referrer: referrer_1 })); });
    }
    // Close preferences <details> when clicking outside.
    document.addEventListener('click', function (e) {
        var details = document.querySelector('.preferences details');
        if ((details === null || details === void 0 ? void 0 : details.open) && !details.contains(e.target)) {
            details.open = false;
        }
    });
    // Intercept every "Add to cart" click sitewide (delegated, not a direct
    // listener -- Fancybox injects its own copy of _item-card.html's
    // caption fresh into the DOM each time its lightbox opens, from the
    // data-caption HTML string, so it doesn't exist to attach a listener to
    // at page load; item.html's own buttons benefit from the same one
    // delegated handler too). Adds via AJAX and stays on the page instead
    // of navigating to /cart -- updates the header badge and sidebar in
    // place, then lets listeners (e.g. runItem()'s mobile quantity stepper)
    // react to the pbex:added-to-cart event. Falls back to a normal
    // navigation if the request fails.
    document.addEventListener('click', function (e) {
        var button = e.target.closest('a[data-add-to-cart]');
        if (!button) {
            return;
        }
        e.preventDefault();
        // Fires at click time, before the add's fetch resolves -- records
        // engagement intent even if the add later fails.
        //
        // The Umami 'Add to Cart' event for EVERY add-to-cart control sitewide
        // (grid quick-add + zoom lightbox, item page inline + mobile bar, the
        // cart/payment review table). Umami's own data-umami-event attribute
        // capture is inert here -- base.html loads the tracker
        // data-auto-track="false" (for the referrer-rewrite pageview in
        // init()), which stops Umami attaching its attribute click listener --
        // so PBex fires the event itself. data-add-to-cart-source is the
        // funnel-source label set per template.
        umamiTrack('Add to Cart', compact({
            from: button.dataset.addToCartSource,
            ref: button.dataset.ref,
        }));
        if (button.closest('#search-result-grid')) {
            emitSearchResultEngagement('add_to_cart', button);
        }
        // Captured before the fetch resolves -- Fancybox.close() below would
        // otherwise have nothing left open to check against by then.
        var wasZoomedIn = Fancybox.getInstance() != null;
        fetch(button.href, { headers: { 'Accept': 'application/json' } })
            .then(function (response) {
            if (!response.ok) {
                throw new Error("Add to cart failed: ".concat(response.status));
            }
            return response.json();
        })
            .then(function (data) {
            var _a, _b;
            applyCartUpdate(data);
            document.dispatchEvent(new CustomEvent('pbex:added-to-cart', { detail: data }));
            if (wasZoomedIn) {
                // Zooms back out first -- Fancybox's own built-in closing
                // transition -- before the item's thumbnail (found below) is
                // visible again to fly from.
                Fancybox.close();
            }
            // button.closest('.item-preview') covers the quick-add pin (see
            // _item-card.html) -- clicked directly on the underlying page, so
            // its own card is a real ancestor. That's never true for the
            // lightbox caption's own copy of this button, injected by
            // Fancybox into a detached container of its own -- data.ref
            // (returned by AddToCartApi regardless of which button was
            // clicked) locates that same item's thumbnail back on the
            // underlying page instead.
            var sourceImg = (_b = (_a = button.closest('.item-preview')) === null || _a === void 0 ? void 0 : _a.querySelector('img.thumbnail')) !== null && _b !== void 0 ? _b : (data.ref
                ? document.querySelector("a.zoom[data-ref=\"".concat(CSS.escape(data.ref), "\"] img.thumbnail"))
                : null);
            if (sourceImg) {
                flyToCart(sourceImg);
            }
        })
            .catch(function (error) {
            Sentry.captureException(error);
            window.location.href = button.href;
        });
    });
    // Intercept currency form: POST via fetch, then reload.
    (_a = document.querySelector('#currency-form')) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', function (e) { return __awaiter(_this, void 0, void 0, function () {
        var form, formData, submitter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    form = e.target;
                    formData = new FormData(form);
                    submitter = e.submitter;
                    if ((submitter === null || submitter === void 0 ? void 0 : submitter.name) && (submitter === null || submitter === void 0 ? void 0 : submitter.value)) {
                        formData.set(submitter.name, submitter.value);
                    }
                    return [4 /*yield*/, fetch(form.action, {
                            method: 'POST',
                            body: formData,
                            headers: { 'Accept': 'application/json' },
                        })];
                case 1:
                    _a.sent();
                    window.location.reload();
                    return [2 /*return*/];
            }
        });
    }); });
    // https://fancyapps.com/fancybox/get-started/usage/
    Fancybox.bind('[data-fancybox]', {
        on: {
            'init': function (fancyboxRef) {
                var _a, _b;
                track('Zoom');
                track('View Item', {
                    category: zoomCategory,
                    sub_category: zoomSubCategory,
                    view_type: 'zoom_in',
                });
                // 'init' fires before slides are built, so getSlide() is still
                // undefined here -- the clicked element is on the instance options
                // (getSlide().triggerEl is the fallback for later events).
                var triggerEl = (_a = fancyboxRef.getOptions().triggerEl) !== null && _a !== void 0 ? _a : (_b = fancyboxRef.getSlide()) === null || _b === void 0 ? void 0 : _b.triggerEl;
                emitSearchResultEngagement('zoom', triggerEl);
            },
            'Carousel.change': function (fancyboxRef, carouselRef) {
                track('View Item', {
                    category: zoomCategory,
                    sub_category: zoomSubCategory,
                    view_type: 'zoom_change',
                });
            },
        },
    });
}
export function runHome(recaptchaSiteKey) {
    umamiTrack('View Home Page');
    grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: 'homepage' });
    });
}
/**
 * category.html / sub-category.html
 * @param categoryName Current category or group slug.
 * @param itemsCount Number of items (sub-categories or products) shown.
 * @param type Whether this is a top-level group or a sub-category listing.
 * @param groupSlug The main category group slug.
 */
export function runCategory(categoryName, itemsCount, type, groupSlug) {
    zoomCategory = groupSlug;
    zoomSubCategory = categoryName;
    gtag('event', 'view_item_list', {
        item_list_id: categoryName,
    });
    umamiTrack("View Category", {
        category: categoryName,
        items_count: itemsCount,
        type: type,
        group: groupSlug,
    });
}
/**
 * item.html
 * @param product Product displayed.
 * @param currencyCode Currency code.
 */
export function runItem(product, currencyCode, isOutOfStock, detectCountry, updateShippingUrl, setCurrencyUrl, updateQuantityUrl) {
    var _a, _b, _c, _d;
    umamiTrack('View Item', {
        category: product.category,
        view_type: 'page',
    });
    // Measuring Views of Product Details - Enhanced Ecommerce
    // See https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item_details
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item
    gtag('event', 'view_item', {
        currency: currencyCode,
        value: product.price,
        items: [convertProductToGA4Item(product)],
        item_list_name: 'Item details',
        out_of_stock: isOutOfStock,
    });
    var items = [convertProductToGA4Item(product)];
    // GA4 add_to_cart ecommerce event for this page's own "Add to cart"
    // buttons (inline + mobile bar). The Umami 'Add to Cart' event is fired
    // for every add-to-cart control sitewide by init()'s delegated
    // data-add-to-cart handler -- not duplicated here.
    $('a[data-add-to-cart]').on('click', function () {
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_to_cart
        gtag('event', 'add_to_cart', {
            currency: currencyCode,
            value: product.price,
            items: items,
        });
    });
    // Mobile "Add to Cart" bar -- always visible while on this page (see
    // style.css); starts as a plain "Add to cart" (handled by init()'s own
    // sitewide delegated data-add-to-cart click handler), then morphs into
    // a quantity stepper + "Go to Basket" once this ref is in the cart,
    // similar to Temu's product page. item.html seeds the initial state
    // server-side (already-in-cart on a returning visit); this only reacts
    // to it changing further during this pageview.
    var mobileBar = document.getElementById('mobile-add-to-cart-bar');
    if (mobileBar) {
        var addButton_1 = document.getElementById('mobile-bar-add');
        var quantityControls_1 = document.getElementById('mobile-bar-quantity');
        var qtyValueEl_1 = document.getElementById('mobile-bar-qty-value');
        var incrementButton_1 = quantityControls_1 === null || quantityControls_1 === void 0 ? void 0 : quantityControls_1.querySelector('.qty-increment');
        var wholesaleHint_1 = document.getElementById('mobile-bar-wholesale-hint');
        var ref_1 = (_a = mobileBar.dataset.ref) !== null && _a !== void 0 ? _a : product.id;
        var maxQuantity_1 = parseInt((_b = mobileBar.dataset.maxQuantity) !== null && _b !== void 0 ? _b : '12', 10);
        // At the max item quantity, "+" is disabled and a wholesale quote is
        // offered instead (see Cart::$maxItemQuantity).
        var updateMaxQuantityState_1 = function (quantity) {
            var atMax = quantity >= maxQuantity_1;
            if (incrementButton_1) {
                incrementButton_1.disabled = atMax;
            }
            if (wholesaleHint_1) {
                wholesaleHint_1.hidden = !atMax;
            }
        };
        var showQuantityMode_1 = function (quantity) {
            if (addButton_1) {
                addButton_1.hidden = true;
            }
            if (quantityControls_1) {
                quantityControls_1.hidden = false;
            }
            if (qtyValueEl_1) {
                qtyValueEl_1.textContent = String(quantity);
            }
            updateMaxQuantityState_1(quantity);
        };
        var showAddMode_1 = function () {
            if (addButton_1) {
                addButton_1.hidden = false;
            }
            if (quantityControls_1) {
                quantityControls_1.hidden = true;
            }
            updateMaxQuantityState_1(0);
        };
        document.addEventListener('pbex:added-to-cart', (function (evt) {
            var _a, _b;
            if (evt.detail.ref === ref_1) {
                maxQuantity_1 = (_a = evt.detail.max_item_quantity) !== null && _a !== void 0 ? _a : maxQuantity_1;
                showQuantityMode_1((_b = evt.detail.item_quantity) !== null && _b !== void 0 ? _b : 1);
            }
        }));
        var setQuantity_1 = function (quantity) {
            fetch(updateQuantityUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                },
                body: "ref=".concat(encodeURIComponent(ref_1), "&quantity=").concat(quantity),
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var _a, _b;
                applyCartUpdate(data);
                maxQuantity_1 = (_a = data.max_item_quantity) !== null && _a !== void 0 ? _a : maxQuantity_1;
                var newQuantity = (_b = data.item_quantity) !== null && _b !== void 0 ? _b : 0;
                if (newQuantity === 0) {
                    showAddMode_1();
                }
                else {
                    showQuantityMode_1(newQuantity);
                }
            })
                .catch(function (error) { return Sentry.captureException(error); });
        };
        (_c = quantityControls_1 === null || quantityControls_1 === void 0 ? void 0 : quantityControls_1.querySelector('.qty-decrement')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            var _a;
            var current = parseInt((_a = qtyValueEl_1 === null || qtyValueEl_1 === void 0 ? void 0 : qtyValueEl_1.textContent) !== null && _a !== void 0 ? _a : '1', 10);
            setQuantity_1(Math.max(0, current - 1));
        });
        (_d = quantityControls_1 === null || quantityControls_1 === void 0 ? void 0 : quantityControls_1.querySelector('.qty-increment')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', function () {
            var _a;
            var current = parseInt((_a = qtyValueEl_1 === null || qtyValueEl_1 === void 0 ? void 0 : qtyValueEl_1.textContent) !== null && _a !== void 0 ? _a : '1', 10);
            setQuantity_1(current + 1);
        });
    }
    var updateItemUI = function (data) {
        $('.shipping-info').removeClass('shipping-loading'); // no-op if it wasn't loading
        if (data.item_price) {
            // The main price and the mobile sticky bar's own copy of it.
            $('#item-price, .mobile-bar-price').html(data.item_price);
        }
        if (data.shipping_cost) {
            $('#shipping-costs').html(data.shipping_cost);
        }
        if (data.estimated_arrival_html) {
            $('#estimated-arrival').html(data.estimated_arrival_html);
        }
        if (data.currency_code) {
            var indicator = $('#currency-indicator');
            var langPart = indicator.text().split('|')[0].trim();
            indicator.text(langPart + ' | ' + data.currency_code);
            $('.currency-btn').removeClass('active');
            $(".currency-btn[value=\"".concat(data.currency_code, "\"]")).addClass('active');
        }
    };
    var updateShipping = function (shippingCountry) {
        $.post(updateShippingUrl, { shipping_country: shippingCountry, item_ref: product.id }, updateItemUI);
    };
    $('select[name=shipping_country]').on('change', function (evt) {
        var shippingCountry = $(evt.currentTarget).val();
        updateShipping(shippingCountry);
    });
    $('#currency-form .currency-btn').on('click', function (evt) {
        evt.preventDefault();
        var newCurrency = $(evt.currentTarget).val();
        $.ajax({
            url: setCurrencyUrl,
            type: 'POST',
            data: { currency: newCurrency, item_ref: product.id },
            dataType: 'json',
            success: updateItemUI,
        });
    });
    if (detectCountry) {
        var dropdown_1 = $('select[name=shipping_country]');
        $.ajax({
            url: 'https://ipinfo.io/json',
            dataType: 'json',
            timeout: 5000,
        }).done(function (response) {
            if (isOfferedShippingCountry(dropdown_1, response === null || response === void 0 ? void 0 : response.country)) {
                dropdown_1.val(response.country);
                updateShipping(response.country);
            }
            else {
                // GeoIP resolved to a country we don't ship to (or returned none) —
                // keep the server-picked default and just resolve the placeholder.
                updateShipping(dropdown_1.val());
            }
        }).fail(function () {
            // GeoIP lookup failed or timed out (e.g. blocked by an ad/privacy
            // blocklist) — fall back to the store's default country via our own
            // backend rather than leaving the "calculating…" placeholder stuck.
            updateShipping(dropdown_1.val());
        });
    }
}
export function runHistory() {
    // https://fancyapps.com/carousel/get-started/usage/
    Carousel(document.querySelector('.f-carousel'), {
        transition: 'tween',
        infinite: false,
        on: {
            change: function (instance) {
                track('Carousel');
            },
        },
    }, { Arrows: Arrows, Dots: Dots }).init();
}
/**
 * cart.html
 * @param recaptchaSiteKey reCaptcha key.
 * @param products Products in the cart.
 * @param currencyCode Currency code (e.g. "EUR").
 */
export function runCart(recaptchaSiteKey, products, currencyCode, detectCountry, updateShippingUrl, confirmRemoveMessage) {
    grecaptcha.ready(function () {
        grecaptcha.execute(recaptchaSiteKey, { action: 'cart' });
    });
    umamiTrack('View Cart', {
        currency: currencyCode,
        cart_total: getProductsTotal(products),
        cart_items_count: products.length,
    });
    // Measuring a Checkout - Enhanced Ecommerce
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_cart
    gtag('event', 'view_cart', {
        currency: currencyCode,
        value: getProductsTotal(products),
        items: convertProductsToGA4Items(products),
    });
    // Measuring Product Clicks.
    $('a.item').on('click', function (evt) {
        var elem = evt.currentTarget;
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item
        var ref = $(elem).data('ref');
        var name = elem.title;
        var price = $(elem).data('price');
        gtag('event', 'view_item', {
            currency: currencyCode,
            value: price,
            items: [{
                    item_id: ref,
                    item_name: name,
                    price: price,
                }],
        });
    });
    // Measuring a Checkout - Enhanced Ecommerce
    $('button[name=checkout]').on('click', function (evt) {
        umamiTrack('Checkout Intent', {
            variant: 'cart',
            currency: currencyCode,
            cart_total: getProductsTotal(products),
            cart_items_count: products.length,
        });
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#begin_checkout
        gtag('event', 'begin_checkout', {
            currency: currencyCode,
            value: getProductsTotal(products),
            items: convertProductsToGA4Items(products),
        });
    });
    $('.quantity-input').on('change', function (evt) {
        var _a;
        var input = evt.currentTarget;
        var quantity = parseInt(input.value, 10);
        var previousValue = input.defaultValue;
        if (quantity === 0) {
            if (confirm(confirmRemoveMessage)) {
                umamiTrack('Remove from Cart', {
                    currency: currencyCode,
                    cart_item_count: products.length,
                });
            }
            else {
                input.value = previousValue;
                return;
            }
        }
        (_a = input.form) === null || _a === void 0 ? void 0 : _a.submit();
    });
    if (detectCountry) {
        // Sets country code using GeoIP.
        // Ideally do this server-side using https://nginx.org/en/docs/http/ngx_http_geoip_module.html
        $.get('https://ipinfo.io/json', function (response) {
            var dropdown = $('select[name=shipping_country]');
            if (!isOfferedShippingCountry(dropdown, response === null || response === void 0 ? void 0 : response.country)) {
                // GeoIP resolved to a country we don't ship to (or returned none) —
                // leave the server-picked default in place.
                return;
            }
            var countryChanged = dropdown.val() != response.country;
            if (countryChanged) {
                dropdown.val(response.country);
            }
            $.post(updateShippingUrl, { 'shipping_country': response.country }, function (data) {
                if (countryChanged || data.currency_changed) {
                    window.location.reload();
                }
            });
        });
    }
}
export function runPaymentForm(products, currencyCode, updateShippingUrl, initialShippingCost) {
    umamiTrack('View Payment Form');
    // Kept current for the add_shipping_info `shipping_tier` on submit; the
    // shipping-country change handler below refreshes it from the API.
    var shippingCost = initialShippingCost;
    var countrySelect = document.querySelector('select[name=shipping_country]');
    var stateLabel = document.querySelector('label.state-field');
    var stateInput = document.querySelector('input[name=state]');
    // Show the State / Province field only for countries whose addresses use one
    // (data-needs-state on each <option>). While hidden it is disabled so it is
    // neither submitted nor picked up by the browser's address autofill.
    var syncStateField = function () {
        var _a;
        if (!countrySelect || !stateLabel || !stateInput) {
            return;
        }
        var needed = ((_a = countrySelect.selectedOptions[0]) === null || _a === void 0 ? void 0 : _a.dataset.needsState) === '1';
        stateLabel.hidden = !needed;
        stateInput.disabled = !needed;
        stateInput.required = needed;
        if (!needed) {
            stateInput.value = '';
        }
    };
    syncStateField();
    $('select[name=shipping_country]').on('change', function (evt) {
        var shippingCountry = $(evt.currentTarget).val();
        countryChanged = true;
        scheduleEngagementSnapshot();
        syncStateField();
        $.post(updateShippingUrl, { 'shipping_country': shippingCountry }, function (data) {
            if (data.currency_changed) {
                // Re-render the page in the new currency without discarding what the
                // customer has already typed. A native form submit posts every field
                // back (and, unlike a click, sends no `submit` button value and skips
                // the jQuery submit handler), so PaymentDocument treats the request as
                // a reload: it merges the posted values into the form instead of
                // validating the order or handing off to the payment gateway.
                // HTMLFormElement.prototype.submit is used explicitly because the
                // form's own `submit` button (name="submit") shadows form.submit().
                var paymentForm = document.querySelector('form.payment');
                if (paymentForm) {
                    HTMLFormElement.prototype.submit.call(paymentForm);
                }
                else {
                    window.location.reload();
                }
                return;
            }
            var parsedShippingCost = Number(data.shipping_cost_amount);
            if (!Number.isNaN(parsedShippingCost)) {
                shippingCost = parsedShippingCost;
            }
            $('#shipping-costs').html(data.shipping_cost);
            $('#cart-total').html(data.total);
            $('#cart-total-header').html(data.total);
            $('#estimated-arrival').html(data.estimated_arrival_html);
        });
    });
    var summaryButton = document.querySelector('#cart-summary button');
    if (summaryButton) {
        var content_1 = document.querySelector('#cart-summary section');
        if (content_1) {
            summaryButton.addEventListener('click', function () {
                content_1.classList.toggle('is-open');
            });
        }
    }
    var STATE_SEVERITY = { stuck: 4, empty: 3, manual: 2, auto: 1, skipped: 0 };
    var STUCK_DWELL_MS = 2000;
    var AUTOFILL_MAX_DELAY_MS = 150;
    var MIN_FILLED_LENGTH = 3;
    var SNAPSHOT_DEBOUNCE_MS = 3000;
    var SNAPSHOT_MAX_WAIT_MS = 15000;
    var trackedFields = [];
    var countryChanged = false;
    var paymentMethodChanged = false;
    var debounceTimer = null;
    var maxWaitTimer = null;
    var lastSentSnapshotJSON = null;
    function classifyField(field) {
        var value = field.element.value.trim();
        if (value.length < MIN_FILLED_LENGTH) {
            if (!field.required()) {
                return 'skipped';
            }
            return field.hadLongEmptyDwell ? 'stuck' : 'empty';
        }
        var looksAutomatic = field.lastInputType === 'insertReplacementText'
            || (field.inputCount === 1 && field.firstInputDelayMs !== null && field.firstInputDelayMs < AUTOFILL_MAX_DELAY_MS);
        return looksAutomatic ? 'auto' : 'manual';
    }
    function computeEngagementSnapshot() {
        var _a;
        var byGroup = new Map();
        for (var _i = 0, trackedFields_1 = trackedFields; _i < trackedFields_1.length; _i++) {
            var field = trackedFields_1[_i];
            var list = (_a = byGroup.get(field.group)) !== null && _a !== void 0 ? _a : [];
            list.push(field);
            byGroup.set(field.group, list);
        }
        var snapshot = {};
        byGroup.forEach(function (fields, group) {
            var worstField = fields[0];
            var worstState = classifyField(worstField);
            for (var _i = 0, _a = fields.slice(1); _i < _a.length; _i++) {
                var field = _a[_i];
                var state = classifyField(field);
                if (STATE_SEVERITY[state] > STATE_SEVERITY[worstState]) {
                    worstField = field;
                    worstState = state;
                }
            }
            snapshot[group] = worstState;
            if (fields.length > 1) {
                snapshot["".concat(group, "_field")] = worstField.element.name;
            }
        });
        snapshot.country = countryChanged ? 'manual' : 'auto';
        snapshot.payment_method = paymentMethodChanged ? 'manual' : 'auto';
        return snapshot;
    }
    function sendEngagementSnapshot(useBeacon) {
        var snapshot = computeEngagementSnapshot();
        var json = JSON.stringify(snapshot);
        if (json === lastSentSnapshotJSON) {
            return;
        }
        lastSentSnapshotJSON = json;
        umamiTrack('Payment Form Engagement', snapshot);
        gtag('event', 'Payment Form Engagement', useBeacon ? __assign(__assign({}, snapshot), { transport_type: 'beacon' }) : snapshot);
    }
    function flushEngagementSnapshot() {
        if (debounceTimer !== null) {
            window.clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        if (maxWaitTimer !== null) {
            window.clearTimeout(maxWaitTimer);
            maxWaitTimer = null;
        }
        sendEngagementSnapshot(false);
    }
    function scheduleEngagementSnapshot() {
        if (debounceTimer !== null) {
            window.clearTimeout(debounceTimer);
        }
        debounceTimer = window.setTimeout(flushEngagementSnapshot, SNAPSHOT_DEBOUNCE_MS);
        if (maxWaitTimer === null) {
            maxWaitTimer = window.setTimeout(flushEngagementSnapshot, SNAPSHOT_MAX_WAIT_MS);
        }
    }
    function trackFieldEngagement(selector, group, required) {
        var element = document.querySelector(selector);
        if (!element) {
            return;
        }
        var field = {
            element: element,
            group: group,
            required: required,
            inputCount: 0, firstInputDelayMs: null, lastInputType: null,
            hadLongEmptyDwell: false, focusStart: null, focusStartInputCount: 0,
        };
        element.addEventListener('focusin', function () {
            field.focusStart = performance.now();
            field.focusStartInputCount = field.inputCount;
        });
        element.addEventListener('input', function (evt) {
            var _a;
            if (field.focusStart !== null && field.firstInputDelayMs === null) {
                field.firstInputDelayMs = performance.now() - field.focusStart;
            }
            field.inputCount++;
            field.lastInputType = (_a = evt.inputType) !== null && _a !== void 0 ? _a : null;
            scheduleEngagementSnapshot();
        });
        element.addEventListener('focusout', function () {
            if (field.focusStart !== null) {
                var elapsed = performance.now() - field.focusStart;
                if (field.inputCount === field.focusStartInputCount && elapsed >= STUCK_DWELL_MS) {
                    field.hadLongEmptyDwell = true;
                }
            }
            field.focusStart = null;
            scheduleEngagementSnapshot();
        });
        trackedFields.push(field);
    }
    trackFieldEngagement('input[name=name]', 'name', function () { return true; });
    trackFieldEngagement('input[name=addressLine1]', 'shipping_address', function () { return true; });
    trackFieldEngagement('input[name=addressLine2]', 'shipping_address', function () { return false; });
    trackFieldEngagement('input[name=city]', 'shipping_address', function () { return true; });
    trackFieldEngagement('input[name=zip]', 'shipping_address', function () { return true; });
    trackFieldEngagement('input[name=state]', 'shipping_address', function () { var _a; return (_a = stateInput === null || stateInput === void 0 ? void 0 : stateInput.required) !== null && _a !== void 0 ? _a : false; });
    trackFieldEngagement('input[name=phone]', 'phone', function () { return true; });
    trackFieldEngagement('input[name=email]', 'other', function () { return true; });
    trackFieldEngagement('textarea[name=comment]', 'other', function () { return false; });
    $('input[name="paymentMethod"]').on('change', function () {
        paymentMethodChanged = true;
        scheduleEngagementSnapshot();
    });
    window.addEventListener('pagehide', function () {
        sendEngagementSnapshot(true);
    });
    $('form.payment').on('submit', function () {
        flushEngagementSnapshot();
        var paymentType = '';
        document.querySelectorAll('input[name="paymentMethod"]').forEach(function (elm) {
            if (elm.checked) {
                paymentType = elm.value;
            }
        });
        umamiTrack('Add Payment Info', {
            payment_type: paymentType,
            currency: currencyCode,
            cart_total: getProductsTotal(products),
            cart_items_count: products.length,
        });
        // Single-page checkout: shipping address and payment method are
        // submitted together. Emit add_shipping_info first so GA4's ordered
        // Checkout journey report sees begin_checkout -> add_shipping_info ->
        // add_payment_info -> purchase.
        // Like add_payment_info below, this fires on every form.payment submit,
        // including one the server later rejects for a validation error.
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_shipping_info
        gtag('event', 'add_shipping_info', {
            currency: currencyCode,
            value: getProductsTotal(products),
            shipping_tier: shippingCost > 0 ? 'Standard' : 'Free',
            items: convertProductsToGA4Items(products),
        });
        // Measuring Purchases - Enhanced Ecommerce
        // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#initiate_the_checkout_process
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_payment_info
        gtag('event', 'add_payment_info', {
            currency: currencyCode,
            value: getProductsTotal(products),
            payment_type: paymentType,
            items: convertProductsToGA4Items(products),
        });
    });
}
export function runPayPalReview(products, currencyCode) {
    track('View PayPal Review');
}
/**
 * payment-paypal-success.html
 * payment-lyra-success.html
 * @param transactionId Translation ID for purchases and refunds.
 * @param total Total transaction value (including tax and shipping).
 * @param shipping Shipping cost.
 * @param products Products in the cart.
 * @param currencyCode Currency code (e.g. "EUR").
 * @param paymentType The chosen method of payment (e.g. "Credit Card").
 */
export function logEcommercePurchase(transactionId, total, shipping, products, currencyCode, paymentType, submittedPurchase, sandbox) {
    if (submittedPurchase) {
        umamiTrack('Purchase Complete', {
            payment_type: paymentType,
            revenue: total,
            currency: currencyCode,
            cart_items_count: products.length,
            shipping: shipping,
            sandbox: sandbox,
        });
    }
    // Measuring Purchases - Enhanced Ecommerce
    // https://developers.google.com/tag-manager/enhanced-ecommerce
    // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#initiate_the_checkout_process
    gtag('event', 'purchase', {
        transaction_id: transactionId,
        currency: currencyCode,
        value: total,
        shipping: shipping,
        items: convertProductsToGA4Items(products),
    });
}
/**
 * payment-offline.html
 *
 * A bank transfer is not a settled payment -- the customer still has to wire
 * the money, and may never do so. Unlike {@link logEcommercePurchase}, this
 * does NOT fire GA4 `purchase` or Umami `Purchase Complete`, so bank-transfer
 * orders aren't counted as completed purchases/conversions. It reports the
 * same order details under distinct, non-conversion event names instead.
 * @param transactionId Translation ID for purchases and refunds.
 * @param total Total transaction value (including tax and shipping).
 * @param shipping Shipping cost.
 * @param products Products in the cart.
 * @param currencyCode Currency code (e.g. "EUR").
 */
export function logBankTransferInitiated(transactionId, total, shipping, products, currencyCode, submittedPurchase, sandbox) {
    if (submittedPurchase) {
        umamiTrack('Bank Transfer Initiated', {
            payment_type: 'Bank Transfer',
            revenue: total,
            currency: currencyCode,
            cart_items_count: products.length,
            shipping: shipping,
            sandbox: sandbox,
        });
    }
    gtag('event', 'bank_transfer_initiated', {
        transaction_id: transactionId,
        currency: currencyCode,
        value: total,
        shipping: shipping,
        items: convertProductsToGA4Items(products),
    });
}
/**
 * email-form.html
 * @param recaptchaSiteKey reCaptcha key.
 */
export function runEmailForm(recaptchaSiteKey) {
    umamiTrack('View Email Form');
    var form = document.getElementById('email-form');
    var submitButton = document.getElementById('email-submit');
    var captchaInput = document.getElementById('email-captcha');
    if (form && submitButton && captchaInput) {
        // Enable the button since we will handle reCAPTCHA on submit.
        submitButton.disabled = false;
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            submitButton.disabled = true;
            if (typeof grecaptcha === 'undefined') {
                form.submit();
                return;
            }
            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: 'email' }).then(function (token) {
                    if (token) {
                        captchaInput.value = token;
                    }
                    umamiTrack('Send Email');
                    form.submit();
                }, function () {
                    umamiTrack('Send Email');
                    form.submit();
                });
            });
        });
    }
}
